export default __webpack_public_path__ + "static/media/VkycLoaderScreen.5596c56a.png";